import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseButtonComponent} from './base-button.component';

// plus-minus-sm-button.component.ts
@Component({
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  selector: 'app-plus-minus-sm-button',
  template: `
    <div class="items-center flex flex-row gap-2">
      <app-base-button
        [baseClass]="'rounded-full w-6 h-6 text-theme-primary text-sm bg-theme-surface2'"
        (onClick)="change(-1)"
        [disabled]="disabled"
        [ngClass]="{'opacity-30': disabled}"
      >
        <i *ngIf="amount<=1" class="fas fa-trash-alt"></i>
        <i *ngIf="amount>1" class="fas fa-minus"></i>
      </app-base-button>

      <div class="text-xl font-bold min-w-8 text-center">{{amount>0?amount:"1"}}</div>

      <app-base-button
        [baseClass]="'rounded-full w-6 h-6 text-theme-primary text-sm bg-theme-surface2'"
        (onClick)="change(1)"
        [disabled]="disabled || disableAdd"
        [ngClass]="{'opacity-30': disabled || disableAdd}"
      >
        <i class="fas fa-plus"></i>
      </app-base-button>
    </div>
  `
})
export class PlusMinusSMButtonComponent {
  @Input() disabled: boolean = false;
  @Input() disableAdd: boolean = false;
  @Input() amount: number = 0;
  @Output() onChangeAmount = new EventEmitter<number>();

  change(number: number) {
    this.onChangeAmount.emit(number);
  }
}
